exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".event-table tr{width:auto}.event-table tr:hover{cursor:pointer}", ""]);

// exports
